/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path, Line } from 'react-native-svg';

import { IconProps } from '../lib';

function Flask(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path
        d="M104,32V93.78413a7.99992,7.99992,0,0,1-1.14006,4.116L39.26958,203.884A8,8,0,0,0,46.12952,216h163.741a8,8,0,0,0,6.85994-12.116L153.14006,97.90009A7.99992,7.99992,0,0,1,152,93.78413V32"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Line
        x1={88}
        y1={32}
        x2={168}
        y2={32}
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
      <Path
        d="M62.61682,164.96456C74.44058,156.34675,94.73752,151.36876,128,168c35.70432,17.85216,56.4696,10.80591,67.852,1.08577"
        fill="none"
        stroke={props.color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={12}
      />
    </Svg>
  );
}

export default Flask;
